export const urlcode = 'https://nbzlapi.sjhlwyy.com'//正式
// export const urlcode = 'http://192.168.40.49:1091/handover'  //fqf
localStorage.setItem('urlcode', urlcode);
export default {urlcode}








// WEBPACK FOOTER //
// ./src/config.js